import { useState } from 'react'
import { EuiFieldSearch, EuiFilterGroup } from '@equipmentshare/ds2'
import useInputDebounce from 'hooks/useInputDebounce'
import { cleanFulfillmentOrderNumber } from '../utils/fulfillmentOrderNumber'

export type FulfillmentOrderNumberFilterProps = {
	initialValue?: string,
	onChange: ( orderNumber: string ) => void,
}

export default function FulfillmentOrderNumberFilter( { initialValue = '', onChange }: FulfillmentOrderNumberFilterProps ) {
	const [ inputValue, setInputValue ] = useState( initialValue )

	useInputDebounce( inputValue, 300, ( debounced: string ) => {
		onChange( cleanFulfillmentOrderNumber( debounced ) )
	} )

	return (
		<EuiFilterGroup>
			<EuiFieldSearch
				aria-label="FO-#"
				placeholder="FO-#"
				value={inputValue}
				onChange={( e ) => setInputValue( e.target.value )}
			/>
		</EuiFilterGroup>
	)
}
